import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// Ant
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
// API
import Api from "@/api/api.js";
// Bug Track
import "@/plugins/airbrake.js";

import PAInput from "@/components/pa-input/PAInput.vue";
import PAContent from "@/components/pa-content/PAContent.vue";
import PAGrid from "@/components/pa-grid/PAGrid.vue";
import PARow from "@/components/pa-grid/pa-row/PARow.vue";
import PACol from "@/components/pa-grid/pa-row/pa-col/PACol.vue";
import PADraggable from "@/components/pa-draggable/PADraggable.vue";
import PASelect from "@/components/pa-select/PASelect.vue";
import PAButton from "@/components/pa-button/PAButton.vue";
import PASelectSearch from "@/components/pa-select-search/PASelectSearch.vue";

Api.update({
  CATALOG_API: process.env.VUE_APP_CATALOG_FRONT_CATALOG_API,
  FACTORY_API: process.env.VUE_APP_CATALOG_FRONT_FACTORY_API,
  PRISMA_RENDER_API: process.env.VUE_APP_CATALOG_FRONT_PRISMA_RENDER_API,
  GOCASE_API: process.env.VUE_APP_CATALOG_FRONT_GOCASE_API,
});

Vue.use(Antd);
Vue.config.productionTip = false;

Vue.directive("pan-h", {
  bind: function (el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el);
      mc.get("pan").set({ direction: Hammer.DIRECTION_HORIZONTAL });
      mc.on("pan", binding.value);
    }
  },
});

Vue.directive("pan", {
  bind: function (el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el);
      mc.get("pan").set({ direction: Hammer.DIRECTION_ALL });
      mc.on("pan", binding.value);
    }
  },
});

Vue.directive("tap", {
  bind: function (el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el);
      mc.on("tap", binding.value);
    }
  },
});

Vue.config.productionTip = false;
Vue.component("pa-content", PAContent);
Vue.component("pa-grid", PAGrid);
Vue.component("pa-row", PARow);
Vue.component("pa-col", PACol);
Vue.component("pa-button", PAButton);
Vue.component("pa-select", PASelect);
Vue.component("pa-draggable", PADraggable);
Vue.component("textInput", PAInput);
Vue.component("pa-select-search", PASelectSearch);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
